import { useEffect, useState } from "preact/hooks";
import { AuthError, completeLogin, startLogin, type AuthErrorReason } from "../auth/auth.ts";
import { defineMessages, useT } from "../i18n/index.ts";

const messages = defineMessages(
  {
    cancelled: "Connexion annulée.",
    "invalid-link": "Lien de connexion invalide ou expiré. Recommencez.",
    failed: "La connexion a échoué. Recommencez.",
    expired: "Session expirée, reconnectez-vous.",
    signIn: "Se connecter",
    signingIn: "Connexion en cours…",
  },
  {
    cancelled: "Sign-in cancelled.",
    "invalid-link": "This sign-in link is invalid or has expired. Please try again.",
    failed: "Sign-in failed. Please try again.",
    expired: "Your session has expired. Please sign in again.",
    signIn: "Sign in",
    signingIn: "Signing in…",
  },
);

export function Callback() {
  const t = useT(messages);
  const [error, setError] = useState<{ reason: AuthErrorReason; detail?: string }>();

  useEffect(() => {
    completeLogin(window.location.search)
      .then((returnTo) => window.location.replace(returnTo))
      .catch((e: Error) => setError(e instanceof AuthError ? { reason: e.reason, detail: e.detail } : { reason: "failed" }));
  }, []);

  return (
    <main class="page page--center">
      {error ? (
        <div class="page-card" role="alert">
          {/* L'explication de la boutique, quand elle en donne une, est affichée telle quelle. */}
          <p>{error.detail ?? t(error.reason)}</p>
          <button type="button" class="reader-button reader-button--primary" onClick={() => void startLogin()}>
            {t("signIn")}
          </button>
        </div>
      ) : (
        <p class="reader-message">{t("signingIn")}</p>
      )}
    </main>
  );
}
